
export default function NotFoundPage() {
    window.location.assign('//' + process.env.REACT_APP_TI_DOMAIN + '/404');
    return null;
}